import { DataGrid, Badge, TooltipV2, AvatarV2 } from '@cimplico/components';
import { Invitation, InvitationStatusEnum } from '../../types/invitation';
import { calcRelativeTime, formatDateTime, formatMixedCase } from '../../utilities/formatting';
import UserRoleBadge from '../user-overview/UserRoleBadge';

type InvitationRowProps = {
    id: string;
    invitation: Invitation;
};

function InvitationRow({ id, invitation }: InvitationRowProps): JSX.Element {
    return (
        <DataGrid.Row id={id}>
            <div className="flex items-center gap-2 truncate">
                <AvatarV2 size="xs" />
                <p className="text-gray-700 text-sm py-2">{invitation.email}</p>
            </div>

            <UserRoleBadge role={invitation.role} />
            <p className="text-gray-700 text-sm">
                {invitation.createdBy.firstName} {invitation.createdBy.lastName}
            </p>
            <Badge
                color={invitation.status === InvitationStatusEnum.PENDING ? 'gray' : 'red'}
                label={formatMixedCase(invitation.status)}
                shape="squared"
                size="small"
                variant="default"
            />
            <TooltipV2 message={formatDateTime(new Date(invitation.expires))}>
                <p className="text-gray-700 text-sm">{calcRelativeTime(new Date(invitation.expires))}</p>
            </TooltipV2>
        </DataGrid.Row>
    );
}

export default InvitationRow;
